export const WorkoutRatings = {
  bindings: {
    rating: '<',
  },

  template: `
    <ul class="d-flex justify-content-between align-items-center px-3 mb-3 bg-gray-100 list-unstyled workout-ratings">
      <li class="h6 mb-0 mr-4">Member Rating</li>
      <li ng-repeat="rating in [1,2,3,4,5] track by $index">
        <i class="fa fa-2x fa-star"
          ng-class="{
            'text-teal-dark': $ctrl.rating >= rating,
            'text-gray-300': $ctrl.rating < rating
          }">
        </i>
      </li>
    </ul>`,
};



// WEBPACK FOOTER //
// ./src/components/Workout/WorkoutRatings.js